import script from "./HomeLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeLayout.vue?vue&type=script&setup=true&lang=js"

import "./HomeLayout.vue?vue&type=style&index=0&id=0155cea5&scoped=true&lang=scss"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0155cea5"]])

export default __exports__